module.exports = __webpack_public_path__ + "img/travelEnvironment.c4aa1c4f.png";